import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import AuthProvider from "./Providers/AuthProvider";
import AppProvider from "./Providers/appProvider/AppProvider";
import { SnackbarProvider } from "notistack";
import * as Api from "./api";
import { addIdToObjectRecursive } from "./utils/idAdd";
import { ErrorBoundary } from "./components/ErrorBoundary";

addIdToObjectRecursive(Api); //we are adding id to each api function so we could use in useswr as key for accurate client side caching
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <SnackbarProvider>
        <AuthProvider>
          <AppProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AppProvider>
        </AuthProvider>
      </SnackbarProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
